let RightsCompressor = {
    /*
        Случаи, когда текущий путь является подстрокой предыдущего или последующего путей
        (напр., "OPERATION_AUTO.columns","OPERATION_AUTO.columns.ACTUAL_COST_BUY"), назовем их "особенными",
        должны быть учтены отдельно. Для таких случаев в объект будет добавлено поле "_": 1,
        при встрече которого функция decompressRights будет понимать,
        что здесь нужно обрезать путь и выделить его в отдельный элемент массива.

        Порядок прав в массиве важен, так как для отлова "особенных" случаев
        мы проверяем содержится ли текущий путь в предыдущем и следующем путях.

        Данная функция НЕ обработает случай как "особенный", если предыдущий и следующий пути не содержат текущий, например:

        [
            "OPERATION_AUTO.columns.MIN_DATE"
            "OPERATION_CUSTOMS.columns",            <-- этот случай не будет отмечен как "особенный"
            "OPERATION_AUTO.columns.MAX_DATE"
            "OPERATION_CUSTOMS.columns.ACTUAL_COST_BUY"
        ]

        Случай выше можно обойти, если перед вызовом функции сортировать массивы прав,
        но так как сортировка - тяжелая операция, было решено от нее отказаться.
    */

    compressRights: (paths) => {
        let obj = {};
        const createObj = (currentObj, keys, index = 0, needsCutting = false) => {
            const key = keys[index];

            if ( !key ) {
                return;
            }

            const hasKey = currentObj.hasOwnProperty(key);

            if ( !hasKey ) { // если такого ключа нет, то добавляем пустой объект.
                currentObj[key] = {};
            }

            const isLast = index === keys.length - 1;

            if ( needsCutting && isLast ) { // если "особый" случай, то добавляем специальное поле
                currentObj[key] = {
                    _: 1,
                    ...currentObj[key]
                };
            }

            if ( index < keys.length ) {
                return createObj(currentObj[key], keys, index + 1, needsCutting);
            }

            return;
        };

        if ( paths ) {
            paths.forEach((path, index, paths) => {
                const keys = path.split(".");

                const isLastPath = index === paths.length - 1;

                const nextPath = paths[index + 1];
                const prevPath = paths[index - 1];

                // "OPERATION.tabs.OPERATION_UNIT".includes("OPERATION.tabs.OPERATION") вернет true, поэтому к path добавим точку
                const nextPathIncludesCurrent = nextPath ? nextPath.includes(`${path}.`) : null;
                const prevPathIncludesCurrent = prevPath ? prevPath.includes(`${path}.`) : null;

                if ( nextPathIncludesCurrent || prevPathIncludesCurrent ) {
                    createObj(obj, keys, 0, true);
                } else {
                    createObj(obj, keys, 0);
                }

                if ( isLastPath && prevPathIncludesCurrent ) {
                    createObj(obj, keys, 0, true);
                }

            });
        }

        return obj;
    },

    decompressRights: (data) => { // принимаем объект
        const results = [];

        if ( !data ) {
            return results;
        }

        const createPath = (currentObj, path) => { // функция принимает объект и текущее значение пути
            let keys = Object.keys(currentObj); // собираем ключи объекта

            if ( keys.length ) { // если объект НЕпустой
                keys.forEach((key) => { // для каждого поля рекурсивно вызываем функцию
                    if ( key === "_" ) { // базовый случай (если объект имеет специальное поле, которое задается функцией encodeRigths)
                        results.push(path);
                    } else {
                        let pathSummary;

                        if ( path ) {
                            pathSummary = `${path}.${key}`;
                        } else {
                            pathSummary = key;
                        }

                        const nextNestedObject = currentObj[key];

                        createPath(nextNestedObject, pathSummary);
                    }
                });
            } else {
                results.push(path);
            }
        };

        createPath(data, "");
        return results;
    }
};

export default RightsCompressor;
